import classNames from 'classnames';
import { instanceOf, number, oneOfType, string } from 'prop-types';

import { useTimer } from '@lootboy/lib/hooks';

import { ReactComponent as Clock } from '../../assets/images/icons/clock.svg';

import styles from './ClockTimer.module.scss';

export default function ClockTimer({ date, className, clockClassName }) {
  const { days, hours, minutes, seconds } = useTimer(date);

  let text = `${seconds || 0}s`;
  if (days) {
    text = `${days}d ${hours}h`;
  } else if (hours) {
    text = `${hours}h ${minutes}m `;
  } else if (minutes) {
    text = `${minutes}m ${seconds}s `;
  }

  return (
    <div className={classNames(styles.wrapper, className)}>
      <Clock className={classNames(styles.clock, clockClassName)} />
      {text}
    </div>
  );
}

ClockTimer.propTypes = {
  date: oneOfType([instanceOf(Date), number]),
  className: string,
  clockClassName: string,
};
